<div class="background">
  <div class="label-container" [class.small]="small()">
    mit
    <span class="label">
      Gratisvorteil
    </span>
  </div>
</div>
